import ApiModel from './ApiModel'

class techtasks extends ApiModel {
}

export default new techtasks('/users');